//waterfall: Teads
const LOG_PREFIX = "[OCM][Custom] "
const Aniview = require('../../services/aniview')
const StoryTeller = require('../../services/story_teller_v2')

let customCode = (utils) => {
  return new Promise((resolve, reject) => {
    var sub_paths = window.location.pathname.replace("/", "").split("/") || [];
    sub_paths = sub_paths.filter(String);

    utils.contentLoaded().then(() => {
      if (window.OCM.pageType === 'Article') {
        if (window.location.href.includes('/politismos/')) {
          // Aniview only
          let selector = document.getElementById('inarticle-agora')
          if (!selector) {
            utils.config.services.aniview.desktop.rules.selector = '.articleSingle__description > p'
            utils.config.services.aniview.mobile.rules.selector = '.articleSingle__description > p'
            utils.config.services.aniview.desktop.rules.position = 3
            utils.config.services.aniview.mobile.rules.position = 3
            utils.config.services.aniview.desktop.rules.place = 'insertAfter'
            utils.config.services.aniview.mobile.rules.place = 'insertAfter'
          }

          utils.waitFor('googletag.pubads', () => {
            utils.config.services.aniview.active = true
            const av = new Aniview(utils, utils.config)
            av.run()
          })
        } else {
          //if(subPaths[0] === 'look' || subPaths[0] === 'politismos' || subPaths[0] === 'viral' || subPaths[0] === 'life' ){
          let rand = Math.random()
          if (rand > 0.30) {
            runOutstream(utils, sub_paths)
          } else {
            let selector = document.getElementById('inarticle-agora')
            if (!selector) {
              utils.config.services.aniview.desktop.rules.selector = '.articleSingle__description > p'
              utils.config.services.aniview.mobile.rules.selector = '.articleSingle__description > p'
              utils.config.services.aniview.desktop.rules.position = 3
              utils.config.services.aniview.mobile.rules.position = 3
              utils.config.services.aniview.desktop.rules.place = 'insertAfter'
              utils.config.services.aniview.mobile.rules.place = 'insertAfter'
            }

            utils.waitFor('googletag.pubads', () => {
              utils.config.services.aniview.active = true
              const av = new Aniview(utils, utils.config)
              av.run()
            })
          }

        }

        outbrain_tracking_code(document.querySelectorAll('.mainContainer')[0])

        if (utils.getParameterByName('st') == '1') {
          utils.config.services.story_teller_v2.active = true
          const st = new StoryTeller(utils, utils.config)
          st.run()
        }
      }
    })

    resolve(true)
  });
};

let runOutstream = (utils, subPaths) => {
  if (utils.config.debug) {
    console.log(LOG_PREFIX + 'Running outstream')
  }

  (function (w, d, s) {
    try {
      d = w.top.document || d;
      w = w.top.document ? w.top : w;
    } catch (e) {
    }

    if (w.teads !== undefined) {
      return;
    }

    let exclude_urls = [
      //{'url': '2935139'}
    ]

    for (var z = 0; z < exclude_urls.length; z++) {
      if (w.location.href.indexOf(exclude_urls[z].url) > -1) {
        return;
      }
    }

    var selector = document.querySelectorAll("#inarticle-agora")[0];
    if (!selector) {
      return
    }

    var cat_placementid = 215146;
    var cat_pageid = 199239;
    var cat_subpaths = subPaths[0];

    switch (cat_subpaths) {
      case 'politismos':
        cat_placementid = 215144;
        cat_pageid = 199237;
        console.log(cat_subpaths);
        break;
      case 'tehnologia-epistimi':
        cat_placementid = 202793;
        cat_pageid = 187690;
        console.log(cat_subpaths);
        break;
      case 'perivallon':
        cat_placementid = 202794;
        cat_pageid = 187691;
        console.log(cat_subpaths);
        break;
      default:
        console.log(cat_subpaths);
    }

    var ttag = function () {
      w.teads.page(cat_pageid).placement(cat_placementid, {
        slider: {allow_corner_position: false, allow_top_position: false},
        "css":"margin: 0px auto 25px; max-width: 650px;",
        "format": "inread",
        "slot": {"insertInside": true, "btf": false, "selector": selector, "minimum": 0},
        callbacks: {
          AdStarted: function (){
            const tc = document.createElement('script');
            tc.src = 'https://cdn.orangeclickmedia.com/assets/tc.js';
            tc.type = 'text/javascript';
            document.head.appendChild(tc);
          }
        }
      }).passback(function () {
        let selector = document.getElementById('inarticle-agora')
        if (!selector) {
          utils.config.services.aniview.desktop.rules.selector = '.articleSingle__description > p'
          utils.config.services.aniview.mobile.rules.selector = '.articleSingle__description > p'
          utils.config.services.aniview.desktop.rules.position = 3
          utils.config.services.aniview.mobile.rules.position = 3
          utils.config.services.aniview.desktop.rules.place = 'insertAfter'
          utils.config.services.aniview.mobile.rules.place = 'insertAfter'
        }

        utils.config.services.aniview.active = true
        const av = new Aniview(utils, utils.config)
        av.run()
      }).serve();
    };
    if (w.teads && w.teads.page) {
      ttag();
    } else if (!w.teadsscript) {
      var protocol = w.location.protocol.match(/^https?:$/) ? w.location.protocol : 'https:';
      s.src = protocol + '//a.teads.tv/media/format/v3/teads-format.min.js';
      s.async = true;
      s.onload = ttag;
      w.teadsscript = d.getElementsByTagName('head')[0].appendChild(s);
    }
  })(window, document, document.createElement('script'));
}


let outbrain_tracking_code = (slot) => {
  if (!slot) {
    return
  }

  let widget = '<div class="OUTBRAIN"  data-widget-id="TR_10" data-ob-contentUrl="' + window.location.href + '" data-ob-installation-key="CYOCM2IDF6569I0FK92EEOL10"></div>'
  let script = document.createElement('script')
  script.async = 'async'
  script.src = 'https://widgets.outbrain.com/outbrain.js'
  slot.parentNode.insertBefore(script, slot)

  slot.insertAdjacentHTML('beforebegin', widget)
}

module.exports = customCode;